import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { ArrowIcon, DropdownWrapper, Hint, StyledLabel, StyledSelect } from "./Dropdown.styles";
var Dropdown = function(_param) /*#__PURE__*/ {
    var label = _param.label, value = _param.value, _options = _param.options, options = _options === void 0 ? [] : _options, title = _param.title, hint = _param.hint, id = _param.id, onChange = _param.onChange, props = _object_without_properties(_param, [
        "label",
        "value",
        "options",
        "title",
        "hint",
        "id",
        "onChange"
    ]);
    return _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(DropdownWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(StyledLabel, {
                        htmlFor: id,
                        children: label
                    }),
                    /*#__PURE__*/ _jsxs(StyledSelect, _object_spread_props(_object_spread({}, props), {
                        id: id,
                        value: value,
                        onChange: onChange,
                        children: [
                            title && /*#__PURE__*/ _jsx("option", {
                                disabled: true,
                                value: -1,
                                children: title
                            }, -1),
                            options.map(function(param) {
                                var itemText = param.label, itemValue = param.value;
                                return /*#__PURE__*/ _jsx("option", {
                                    value: itemValue,
                                    children: itemText
                                }, itemValue);
                            })
                        ]
                    })),
                    /*#__PURE__*/ _jsx(ArrowIcon, {})
                ]
            }),
            hint && /*#__PURE__*/ _jsx(Hint, {
                children: hint
            })
        ]
    });
};
export { Dropdown };
